<template>
  <div class="flex flex-col w-full md:w-[75%] items-start min-h-[70px]">
    <p
      class="dark:text-[#5b4e46] rounded-[12px] bg-white dark:bg-[#2e2d38] p-4 space-x-2"
    >
      <span class="font-bold text-base text-[#2d2740] dark:text-gold"
        >{{ item.user.name }}:</span
      >
      <span
        class="leading-relaxed tracking-wide text-tolopea dark:text-white"
        >{{ item.note }}</span
      >
    </p>
    <span
      class="font-semibold text-xs text-[#b0b4bb] dark:text-[#676f7d] inline-block pr-2 pt-[2px]"
      >{{ item.diff }}</span
    >
  </div>
</template>

<script>
export default {
  name: "EloConversation",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {},
};
</script>
